import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import styles from './AddUserModal.module.scss';
import Checkbox from '../../common/Checkbox';
import Input from '../../blocks/Input';
import { requiredValidator, emailValidator } from '../../../utils/validators';

export function AddUserModal(props) {
  const { onClose, open = false } = props;

  const [reorder, setReorder] = useState(false);
  const [dropship, setDropship] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [form, setForm] = useState({
    email: '',
    administration_permission: '',
    ecommerce_permission: '',
    replenish_permission: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    const data = {
      email: form.email,
      administration_permission: admin ? 'write' : 'none',
      ecommerce_permission: dropship ? 'write' : 'none',
      replenish_permission: reorder ? 'write' : 'none',
    };

    setForm({
      email: '',
      administration_permission: '',
      ecommerce_permission: '',
      replenish_permission: '',
    });

    setReorder(false);
    setDropship(false);
    setAdmin(false);

    props.addUser(data);

    event.preventDefault();
    onClose();
  };

  return (
    <ModalWindow open={open} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <h2>Add user</h2>
        <hr />
        <div className={styles.body}>
          <div>
            <label htmlFor="email">
              <span>Email address</span>
              <Input
                name="email"
                type="email"
                onChange={handleChange}
                placeholder="Email"
                value={form.email}
                validate={[requiredValidator, emailValidator]}
                blur
                autocomplete="email"
              />
            </label>
            <div className={styles.services}>
              <span className={styles.allowed}>Allowed services:</span>
              <Checkbox value="Reorder" checked={reorder} onChange={setReorder} />
              <Checkbox value="Drop Ship" checked={dropship} onChange={setDropship} />
              <Checkbox value="Retailer Administration" checked={admin} onChange={setAdmin} />
            </div>
          </div>
        </div>
        <hr />
        <div className={styles.footer}>
          <Button type="submit" text="SAVE" disabled={!(reorder || admin || dropship)} />
          <Button color="white" text="CANCEL" onClick={onClose} />
        </div>
      </form>
    </ModalWindow>
  );
}

AddUserModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  addUser: PropTypes.func.isRequired,
};
